// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"5e755198","287":"9d18cbab","376":"7e53032e","444":"eb8dc4d6","453":"867745f6","619":"e2d191c8","711":"5257b1e1","836":"cd77b2c2","904":"bb60c9a2"}[chunkId] + ".chunk.js";
};